import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pw_visibility",
  "use": "icon-pw_visibility-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-pw_visibility\"><defs><style>#icon-pw_visibility .cls-1{fill:#afb7bc;}</style></defs><path class=\"cls-1\" d=\"M12,4.5A11.82682,11.82682,0,0,0,1,12a11.81667,11.81667,0,0,0,22,0A11.82682,11.82682,0,0,0,12,4.5ZM12,17a5,5,0,1,1,5-5A5.00182,5.00182,0,0,1,12,17Zm0-8a3,3,0,1,0,3,3A2.996,2.996,0,0,0,12,9Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol